function HidableComponent(props) {
  console.log(props.hide);
  const view = <div>{props.children}</div>;
  if (props.hide !== undefined || props.hide === false) return null;
  return view;
}

export default HidableComponent;
